// Route Code Edited 1/30/26
/**
 * BFCache and Popstate Handler Script
 * 
 * This script automatically detects when:
 * 1. A page is restored from bfcache (pageshow event)
 * 2. Browser navigation occurs via back/forward buttons (popstate event)
 * 
 * Actions taken:
 * 1. Checks for open cart drawers or if user is on cart page
 * 2. Removes Route items from cart if present
 * 3. Refreshes the page to update cart UI and reinitialize Route scripts
 * 
 * Installation:
 * Add this script tag at the bottom of layout/theme.liquid (before </body>):
 * 
 * <script src="{{ 'route-bfcache-handler.js' | asset_url }}" defer></script>
 * 
 */
(function() {
    const DRAWER_CART_SELECTOR = 'cart-drawer.active';
       
    const run = () => {
        const hasOpenDrawer = !!document.querySelector(DRAWER_CART_SELECTOR);
        const isCartPage = /\/cart\/?$/.test(location.pathname);
        
        // Only run on cart page or when drawer is open
        if (!hasOpenDrawer && !isCartPage) return;
        
        fetch('/cart.js')
            .then(res => res.ok ? res.json() : Promise.reject(res.status))
            .then(cart => {
                // Find Route item in cart
                const route = (cart.items || []).find(item => item.vendor === 'Route');
                
                // Remove Route item if present, otherwise resolve immediately
                if (route?.key) {
                    return fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({updates: {[route.key]: 0}})
                    });
                }
                return Promise.resolve(); // No Route item, continue to reload
            })
            .catch(error => {
                console.error('Cart operation failed:', error);
                // Continue to reload even if cart operations fail
            })
            .then(() => {
                location.reload(); // Refresh after removal completes (or if no Route item)
            });
    };
    // Handle bfcache restoration (forward/back navigation)
    addEventListener('pageshow', e => e.persisted && run());
    
    // Handle browser back button with delay for drawer state
    addEventListener('popstate', () => setTimeout(() => run(), 100));
})();
// End Route Code